import { Model } from "pinia-orm";
import type { StoreFields } from "@/store/@types/store-fields";
import type { WebinarRo } from "@backend/modules/webinar/dto/webinar-ro";

export class WebinarModel extends Model implements WebinarRo {
  public static entity = "Webinar";
  public static primaryKey = "_id";

  public static fields = (): StoreFields<WebinarRo> => ({
    _id: this.attr(null),
    start_date: this.attr(null),
    end_date: this.attr(null),
    link: this.attr(null),
    name: this.attr(null),
  });

  public declare _id: string;
  public declare start_date: Date;
  public declare end_date: Date;
  public declare link: string;
  public declare name: string;
}
